module.exports = __webpack_public_path__ + "2b8b3a2fd508f8b216846d04666b109c.svg";